import React from 'react';
import { cn } from '../../lib/utils';

const STATUS_STYLES = {
  MATCH_OK: {
    bg: 'bg-[#C4A052]/15',
    border: 'border-[#C4A052]/40',
    text: 'text-[#C4A052]',
    label: 'Matché',
  },
  ANNULEE: {
    bg: 'bg-red-400/10',
    border: 'border-red-400/30',
    text: 'text-red-400',
    label: 'Annulée',
  },
  VALIDE: {
    bg: 'bg-emerald-400/10',
    border: 'border-emerald-400/30',
    text: 'text-emerald-400',
    label: 'Validé',
  },
  LIVRE: {
    bg: 'bg-red-400/10',
    border: 'border-red-400/30',
    text: 'text-red-400',
    label: 'Livré',
  },
  SPECIAL_MATCH: {
    bg: 'bg-amber-400/10',
    border: 'border-amber-400/30',
    text: 'text-amber-400',
    label: 'Spécial',
  },
  DOUBT: {
    bg: 'bg-amber-400/10',
    border: 'border-amber-400/30',
    text: 'text-amber-400',
    label: 'Doute',
  },
  DOUBLON: {
    bg: 'bg-orange-400/10',
    border: 'border-orange-400/30',
    text: 'text-orange-400',
    label: 'Doublon',
  },
};

export const StatusBadge = ({ status, className }) => {
  const normalizedStatus = status?.toUpperCase?.() || '';
  const style = STATUS_STYLES[normalizedStatus];

  if (!style) {
    return (
      <span className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        'bg-zinc-500/10 border border-zinc-500/30 text-zinc-400',
        className
      )}>
        -
      </span>
    );
  }

  return (
    <span className={cn(
      'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border',
      style.bg,
      style.border,
      style.text,
      className
    )}>
      {style.label}
    </span>
  );
};

export const TypeBadge = ({ type, className }) => {
  const isAchat = type?.toUpperCase?.() === 'ACHAT';

  return (
    <span className={cn(
      'inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border',
      isAchat
        ? 'bg-emerald-400/15 border-emerald-400/30 text-emerald-400'
        : 'bg-red-400/15 border-red-400/30 text-red-400',
      className
    )}>
      {isAchat ? 'ACHAT' : 'VENTE'}
    </span>
  );
};

export const getRowStatusClass = (status, ticket = {}) => {
  // Priority: LIVRE (red) > VALIDE (green) > SPECIAL_MATCH (gold) > ANNULEE (red) > PARTIAL (sky-blue) > Attribué (blue) > Default (black)
  const normalized = status?.toUpperCase?.() || '';
  
  // LIVRE = delivered, red background - highest priority
  if (normalized === 'LIVRE') {
    return '!bg-red-600/30 border-l-4 !border-l-red-500';
  }
  
  // VALIDE = validated/confirmed, green background
  if (normalized === 'VALIDE') {
    return '!bg-emerald-600/30 border-l-4 !border-l-emerald-500';
  }
  
  // SPECIAL_MATCH = special attribution (different category) - gold/amber background
  if (normalized === 'SPECIAL_MATCH') {
    return '!bg-amber-500/30 border-l-4 !border-l-amber-500';
  }
  
  // ANNULEE = cancelled - red background
  if (normalized === 'ANNULEE') {
    return '!bg-red-600/30 border-l-4 !border-l-red-500';
  }
  
  // PARTIAL attribution → sky-blue (ciel) background (HIGHER priority than regular "attribué")
  if (ticket.attribution_status === 'partial') {
    return '!bg-sky-500/30 border-l-4 !border-l-sky-400';
  }
  
  // Check if ticket is attributed
  const isAchat = ticket.type?.toUpperCase?.() === 'ACHAT';
  const isAttribue = ticket.attribue === true;
  
  if (isAchat) {
    const hasRefVente = ticket.ref_vente && ticket.ref_vente.trim() !== '';
    if (isAttribue || hasRefVente) {
      return '!bg-blue-600/40 border-l-4 !border-l-blue-500';
    }
  } else {
    if (isAttribue) {
      return '!bg-blue-600/40 border-l-4 !border-l-blue-500';
    }
  }
  
  // Other status colors (lighter)
  switch (normalized) {
    case 'MATCH_OK':
      return 'bg-[#C4A052]/[0.03]';
    case 'DOUBT':
      return 'bg-amber-400/[0.03]';
    case 'DOUBLON':
      return 'bg-orange-400/[0.03]';
    default:
      return '';
  }
};
